import { REDUX_ASSOCIATION_TO_SAVE } from '../../constants/association'
import { MODEL_KEY } from '../../../model/constants'

import { getForeignKeyReduxUtil, getSavableAssociationKeysReduxUtil } from '../get-associations-keys'
import getClassNameReduxUtil from '../get-class-name'
import isNewReduxUtil from '../is-new'
import validateReduxUtil from '../validate'
import { omitObjectUtil, pickObjectUtil } from 'packages/src'

export default function getSavableDataReduxUtil (instance) {
  let savableAssociationKeys = getSavableAssociationKeysReduxUtil(instance)
  let {
    data,
    changed
  } = instance

  const className = getClassNameReduxUtil(instance)
  if (!data) {
    return
  }

  // If some keys are not valid, don't send them
  // e.g. Profile birthday is wrong and some other values are valid
  const validation = validateReduxUtil(instance)
  if (validation) {
    const invalidKeys = validation.map(valElement => valElement.key)
    changed = omitObjectUtil(changed, invalidKeys)
  }

  // If it has not changed, only send the associations and foreign keys
  // which could have changed themselves.
  // Then the server will know not to update them if not necessary
  // const hasNotChanged = isEmptyUtil(omitObjectUtil(changed, savableAssociationKeys))
  // if (hasNotChanged) {
  const foreignKeysToSave = getForeignKeyReduxUtil(data)

  let keysToSave = [
    MODEL_KEY.CLASS_NAME,
    MODEL_KEY.ID,
    ...foreignKeysToSave
  ]

  if (isNewReduxUtil(instance)) {
    keysToSave = [
      ...keysToSave,
      ...savableAssociationKeys
    ]
  } else {
    // e.g. Exercise -> Media
    const associationKeysToSave = REDUX_ASSOCIATION_TO_SAVE[className] || []
    savableAssociationKeys = savableAssociationKeys.filter(assocKey => !associationKeysToSave.includes(assocKey))
    data = omitObjectUtil(data, savableAssociationKeys)
    changed = omitObjectUtil(changed, savableAssociationKeys)
    changed = {
      ...changed,
      ...pickObjectUtil(changed, associationKeysToSave)
    }
  }

  return {
    className,
    ...pickObjectUtil(data, keysToSave),
    ...changed
  }
  // }
  // If the instance has changed, update it
  // return getUpdatedDataReduxUtil(instance)
}
